import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["type", "axles", "preset"]

  connect() {
    this.sync()
  }

  apply({ params }) {
    this.typeTarget.value = params.vehicleType
    this.axlesTarget.value = params.axleCount
    this.sync()
  }

  sync() {
    this.presetTargets.forEach((button) => {
      const selected = button.dataset.tollClassificationVehicleTypeParam === this.typeTarget.value &&
        button.dataset.tollClassificationAxleCountParam === this.axlesTarget.value

      button.classList.toggle("btn-primary", selected)
      button.classList.toggle("btn-outline-secondary", !selected)
      button.setAttribute("aria-pressed", selected.toString())
    })
  }
}
